import { createSelector } from 'reselect';
import UsersConstants from 'Shared/constants/Users.constants';

// TODO (josh) : this key should come from a constant
const getUsersItems = state => state.usersItems;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getRoleParam = createParameterSelector(params => params.role);
const getUserIdParam = createParameterSelector(params => params.userId);
const getUserSlugParam = createParameterSelector(params => params.userSlug);
const getUsersIdsParam = createParameterSelector(params => params.userIds);

export const getAllUsers = createSelector([getUsersItems], users => users.get(UsersConstants.State.USERS_BY_USER_ID));

export const getUserByUserId = createSelector([getAllUsers, getUserIdParam], (users, id) => users.get(id));

export const getUserByUserSlug = createSelector([getAllUsers, getUserSlugParam], (users, slug) => {
  return users.find(user => user.get('slug') === slug);
});

export const getUsersByUserIds = createSelector([getAllUsers, getUsersIdsParam], (users, ids) => {
  return users.filter(user => ids.includes(user.get('id')));
});

export const getUsersByRole = createSelector([getAllUsers, getRoleParam], (users, filter) =>
  users.filter(user => user.get('role') === filter)
);

export const sortUsersByName = createSelector([users => users], users =>
  users.sortBy(user => user.get('fullName') || user.get('email'))
);
